import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";

import BorderTabContent from "./FTPTabContent";
import BorderNav from "./FTPNav";

import { useLocation } from "react-router-dom";
import FTPNav from "./FTPNav";
import FTPTabContent from "./FTPTabContent";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";

export default function FTPTabs() {
    const location = useLocation();
  
    const [basicTab, setBasicTab] = useState<string>('1');

    return (
        <div className="page-body p-2">
            <Col xxl={12}>
                <Card>
                    <CardHeaderSpan headingClassName='py-2 px-2' back={true} heading={'FTP'} span={'Profile'} />

                    {/* <CommonCardHeader headClass="card-no-border pb-0" title={BorderTabsTitle} subTitle={borderTabsSubTitle} /> */}
                    <div className="">
                        <FTPNav basicTab={basicTab} setBasicTab={setBasicTab} />
                        <FTPTabContent tabId={basicTab} />
                    </div>
                </Card>
            </Col>
        </div>
    )
}
